import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { SemanticUI } from '@iterable/deprecated_react_components';
import { PopoverContent } from 'ui/popover';

export const PickerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(5)}; /** css file conversion */
`;

export const SaturationContainer = styled.div`
  position: relative;
  height: ${pxToRem(200)}; /** css file conversion */
  width: ${pxToRem(200)}; /** css file conversion */
`;

export const HueContainer = styled.div`
  position: relative;
  height: ${pxToRem(10)}; /** css file conversion */
`;

export const PresetContainer = styled.div`
  display: flex;
  justify-content: space-around;
  gap: ${pxToRem(1)};
`;

export const Preset = styled.div`
  height: ${pxToRem(17)};
  width: ${pxToRem(17)};
  transition: border-radius 0.3s;
  &[data-selected='true'] {
    border-radius: 100%;
  }
`;

export const StyledCoreInput = styled(SemanticUI.Input)`
  &&&& {
    > input {
      width: ${pxToRem(152)}; /** css file conversion */
    }
  }
`;

export const StyledPopoverContent = styled(PopoverContent)`
  z-index: 100000;
`;

export const ColorBox = styled.div`
  border-radius: ${pxToRem(3)}; /** css file conversion */
  border: ${pxToRem(1)} solid rgba(0, 0, 0, 0.2);
  cursor: pointer;
  height: ${pxToRem(30)};
  width: ${pxToRem(30)};
  &:hover {
    border-color: rgba(0, 0, 0, 0.5);
  }
`;
